"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils = __importStar(require("./columnUtils"));
const BaseColumn_1 = require("./BaseColumn");
const MultilineTextStyle_1 = require("../style/MultilineTextStyle");
class MultilineTextColumn extends BaseColumn_1.BaseColumn {
    constructor(option = {}) {
        super(option);
    }
    get StyleClass() {
        return MultilineTextStyle_1.MultilineTextStyle;
    }
    clone() {
        return new MultilineTextColumn(this);
    }
    drawInternal(value, context, style, helper, _grid, { drawCellBase, getIcon }) {
        const { textAlign, textBaseline, color, font, bgColor, padding, lineHeight, autoWrapText, lineClamp, textOverflow, } = style;
        if (bgColor) {
            drawCellBase({
                bgColor,
            });
        }
        const multilines = value
            .replace(/\r?\n/g, "\n")
            .replace(/\r/g, "\n")
            .split("\n");
        helper.testFontLoad(font, value, context);
        utils.loadIcons(getIcon(), context, helper, (icons, context) => {
            helper.multilineText(multilines, context, {
                textAlign,
                textBaseline,
                color,
                font,
                padding,
                lineHeight,
                autoWrapText,
                lineClamp,
                textOverflow,
                icons,
            });
        });
    }
}
exports.MultilineTextColumn = MultilineTextColumn;
